<ng-container *transloco="let t;">

  <p-card *ngIf="auth.canSeeFiles()">
    <h2>{{ t('common.labels.documents') }}</h2>

    <div class="p-mb-4" [ngClass]="{readonly: inEdit !== true}">
      <p-fileUpload
        [disabled]="inEdit !== true || submitting === true || hasRight === false"
        name="myfile[]"
        multiple="multiple"
        accept=".jpg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx"
        maxFileSize="10000000"
        customUpload="true"
        [files]="files"
        [chooseLabel]="t('common.labels.add')"
        [chooseStyleClass]="'p-button-secondary p-button-outlined'"
        [showUploadButton]="false"
        [showCancelButton]="false"
        (onSelect)="setFiles($event)"
        (onClear)="clearFiles($event)"
        [invalidFileSizeMessageSummary]="t('common.messages.invalidFileSizeMessageSummary')"
        [invalidFileSizeMessageDetail]="t('common.messages.invalidFileSizeMessageDetail')"
        [invalidFileTypeMessageSummary]="t('common.messages.invalidFileTypeMessageSummary')"
        [invalidFileTypeMessageDetail]="t('common.messages.invalidFileTypeMessageDetail')"
        [invalidFileLimitMessageDetail]="t('common.messages.invalidFileLimitMessageDetail')"
        [invalidFileLimitMessageSummary]="t('common.messages.invalidFileLimitMessageSummary')"
      >
        <ng-template pTemplate="content" let-files>
          <div *ngIf="files.length === 0 && inEdit !== true" style="text-align: center;">{{ t('common.labels.no_documents') }}</div>
          <div *ngIf="files.length === 0 && inEdit === true" style="text-align: center;">{{ t('common.labels.choose_files') }}</div>
        </ng-template>

        <ng-template let-file pTemplate="file">
          <div class="p-grid p-fluid p-ai-center" *ngIf="settings[file.name]">
            <div class="p-col-6">
              <p *ngIf="settings[file.name].name">
                {{ settings[file.name].name }}
                <p-tag *ngIf="settings[file.name].status" [styleClass]="settings[file.name].status || ''">{{ t('common.labels.' + settings[file.name].status) }}</p-tag>
              </p>
            </div>
            <div class="p-col-2">
              <app-form-control *ngIf="settings[file.name].control" [cid]="file.name" [control]="settings[file.name].control" [type]="'select'" [options]="optionsDocumenttypes" [showLabel]="false" [noMargin]="true" [edit]="inEdit" [basevalue]="(settings[file.name].control.value) ? t('common.labels.' + settings[file.name].control.value) : ''"></app-form-control>
            </div>
            <div class="p-col-2">
              <app-form-control *ngIf="settings[file.name].candidateControl && settings[file.name].control.value === 'man_report'" [cid]="file.candidate" [control]="settings[file.name].candidateControl" [type]="'select'" [options]="optionsCandidates" [showLabel]="false" [noMargin]="true" [edit]="inEdit" [basevalue]="getCandidateName(settings[file.name].candidateControl.value)"></app-form-control>
            </div>
            <div class="p-col-2 p-text-right">
              <button *ngIf="isFinishable(file)" pButton (click)="finishReport(settings[file.name])" type="button" icon="pi pi-lock" class="p-button-outlined" [disabled]="(submitting === true) ? true : null" [pTooltip]="t('common.labels.finish_report')" tooltipPosition="left"></button>
              <button *ngIf="inEdit !== true" pButton (click)="downloadFile(settings[file.name].id, settings[file.name].name, settings[file.name].type, settings[file.name].candidateControl.value)" type="button" icon="pi pi-download" class="p-ml-2 p-button-outlined" [pTooltip]="t('common.labels.download')" tooltipPosition="left"></button>
              <button *ngIf="inEdit === true && settings[file.name].changable === true" pButton (click)="removeFile(file)" type="button" icon="pi pi-trash" class="p-ml-2 p-button-outlined danger-button" [disabled]="(submitting === true) ? true : null" [pTooltip]="t('common.labels.delete')" tooltipPosition="left"></button>
            </div>
          </div>
        </ng-template>

      </p-fileUpload>
    </div>
  </p-card>

</ng-container>
